<template>
  <el-card>
    <div slot="header">
      <h1 class="has-operation">
        <span>“{{company.name}}”员工列表</span>
      </h1>
      <div class="header-index-content">
        <p>请下载员工导入模板，按照表格模板添加公司员工</p>
        <p class="content-link">
          <a href="javascript:;" @click="downloadTemplate">
            <icon name="arrow_downward" />下载导入模板
          </a>
          <uploader
            target="company-staffs-import"
            :params="{companyId: companyId}"
            @success="handleImportSuccess"
            @error="handleImportError"
            accept=".xlsx,.xls,.csv"
          >
            <a href="javascript:;">
              <icon name="arrow_upward" />导入
            </a>
          </uploader>
        </p>
      </div>
      <div class="header-index-content" v-if="exit || err">
        <p style="color: red">以下手机号添加失败</p>
        <div style="margin-top: 10px" v-if="exit">
          <p>
            <span>重复：</span>
            <span>{{exit}}</span>
          </p>
        </div>
        <div style="margin-top: 10px">
          <p v-if="err"><span>格式不正确：</span>
            <span>{{err}}</span></p>
        </div>

      </div>
    </div>
    <el-form inline :model="staffQuery" class="filter-form">
      <el-form-item label="手机号">
        <el-input v-model="staffQuery.mobile" placeholder="手机号" />
      </el-form-item>
     <el-form-item label="姓名">
        <el-input v-model="staffQuery.userName" placeholder="姓名" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table class="table block" v-loading="loading" :data="collection">
      <el-table-column prop="createdAt" label="添加时间" />
      <el-table-column prop="mobile" label="手机号" />
      <el-table-column prop="userName" label="姓名" />
      <el-table-column prop="address" label="所在地址" />
      <el-table-column prop="center" label="所属中心" />
<!--      <el-table-column prop="email" label="企业邮箱" />-->
<!--      <el-table-column prop="dingTalk" label="钉钉" />-->
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="removeStaff(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
  </el-card>
</template>

<script>

  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'

  const { mapGetters } = createNamespacedHelpers('companyStaffs')

  export default {
    data() {
      return {
        err:'',
        exit:'',
        loading: false,
        companyId: 0,
        company: {},
        query: {
        },
        staffQuery: {
          mobile: ''
        },
      }
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
    },
    methods: {
      async queryCollection({pagination = {}} = {}) {
        let query = {
          companyId: this.companyId,
          mobile: this.staffQuery.mobile ? this.staffQuery.mobile : undefined,
          userName: this.staffQuery.userName ? `%${this.staffQuery.userName}%` : undefined,
          ...this.query,
        }


        try {
          this.loading = true
          await this.$store.dispatch('companyStaffs/collection', {
            query,
            pagination
          })
        } finally {
          this.loading = false
        }
      },

      async removeStaff(staff) {
        await this.$confirm(`是否确定将【${staff.mobile}】从清单中移除？`)
        await this.$store.dispatch('companyStaffs/remove', staff)
        await this.queryCollection()
        this.$message.success('员工删除操作完成')
      },

      async downloadTemplate() {
        this.$linkHelper.redirect('company-staffs-template')
      },
      handleImportSuccess(res) {
        console.log(res)
        this.$message.success(`成功导入了${res.count}条数据`)
        let exit = '';
        let err = ''
        res.exit.map(function (item) {
            exit += item+' '
        })
        res.err.map(function (item) {
          err += item+' '
        })
        this.exit = exit
        this.err = err
        this.queryCollection()
      },
      handleImportError(error) {
        this.$confirm('导入失败了：' + error.message)
        // this.$message.error('导入失败了：' + error.message)
      }
    },
    async mounted() {
      const { id } = this.$route.params
      this.companyId = id

      this.queryCollection()

      const { document } = await this.$store.dispatch('companies/document', id)
      this.company = document
    }
  }
</script>

<style scoped>

</style>
